// ng build --configuration qa

import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: true,
  name: 'qa',
  apiEndpoint: 'https://api-qa.timtravel.app/api/',
};

// Export all settings of common replaced by dev options
export const environment = { ...commonEnv, ...env };
